const studentUser4 = {
  id: '228f7a80-37a5-11e8-ad37-e39b79a1a3a0',
  email: 'jeremy@example.com',
  username: '',
  firstName: 'Jeremy',
  lastName: 'Sanders',
  fullName: 'Jeremy Sanders',
  lastModified: 1522804302376,
  created: 1522804302376,
  role: 'Student',
  schoolDistrict: '8f5ffe80-31fd-11e8-910c-795d7b4ac245',
  school: 'fc200040-37a4-11e8-ad37-e39b79a1a3a0',
  classes: {
    '25446750-4d5c-11e8-9ffe-1b9120b9f9f7': true,
  },
  state: 'TX',
  validated: true,
}

export default studentUser4


// WEBPACK FOOTER //
// ./src/helpers/users/testing/studentUser4.js